<!-- excel添加商品弹窗 -->
<template>
  <div class="excelImportContainer">
    <header>
      <div class="headerText">
        <!-- 请先下载Excel模板表格，再上传文件 -->
        1、{{ $t("message.pleaseDownloadTUploadTheFile") }}。
      </div>
      <el-link
        :href="inventoryExcelUploadUrl + code"
        :underline="false"
        target="_blank"
      >
        <div class="flexAndCenter">
          <img
            :src="require('@/assets/icon/templatedownloadIcon.png')"
            alt=""
          />
          <!-- 下载模板 -->
          <div>{{ $t("message.downloadTemplate") }}</div>
        </div>
      </el-link>
    </header>
    <section>
      <!-- 请选择上传文件 -->
      <div class="sectionTitle">
        2、{{ $t("message.pleaseSelectTheUploadFile") }}。
      </div>
      <div class="uploadContainer flexAndCenter">
        <div class="uploadHeaderContainer flexAndCenter">
          <el-upload
            drag
            class="upload-demo"
            :action="inventoryTplDownloadUrl"
            :show-file-list="false"
            :headers="headers"
            :on-success="handleAvatarSuccess"
            name="file"
            :http-request="httpup"
            accept=".Xls,.Xlsx"
            :before-upload="beforeAvatarUpload"
          >
            <img :src="require('@/assets/icon/folderIcon.png')" alt="" />
            <!-- 点击上传 -->
            <div>{{ $t("message.clickUpload") }}</div>
          </el-upload>
        </div>
        <div class="uploadFooterContainer">
          <!-- 文件格式仅限Xls和Xlsx -->
          <div>{{ $t("message.fileFormatLimitedToXlsAndXlsxOnly") }}</div>
        </div>
      </div>
    </section>
    <div class="fontSize12 colorB4272B" style="margin-top: 12px">
      <!-- 文件解析成功后，商品将直接在商品库里展示，重复的商品会按照文件编辑好的内容进行覆盖 -->
      *{{ $t("message.afterSuccestentOfTheFile") }}。
    </div>
  </div>
</template>

<script>
export default {
  name: "excelImport",
  data() {
    return {
      uploadFileList: [],
      code: "",
      // 后台的下载模板接口报登录失效,就用前台的了
      inventoryExcelUploadUrl:
        location.host.indexOf(".co.jp") !== -1 ||
        location.host.indexOf(".com") !== -1
          ? "https://apiwww.rakumart.com/client/favorite.inventoryTplDownload?rand="
          : "https://jpapi.rakumart.cn/client/favorite.inventoryTplDownload?rand=",

      inventoryTplDownloadUrl: this.baseURL + "/client.inventoryExcelUpload",
    };
  },
  computed: {
    headers() {
      return {
        ClientToken: "Bearer " + localStorage.getItem("japan_user_token"),
      };
    },
  },
  created() {
    for (var i = 0; i < 7; i++) {
      this.code += parseInt(Math.random() * 10);
    }
  },
  methods: {
    httpup(file) {
      let formData = new FormData();
      formData.append("user_id", this.$route.query.userID); //传文件的时候result.name需要传一下,否则可能没有后缀名
      formData.append("file", file.file, file.file.name); //传文件的时候result.name需要传一下,否则可能没有后缀名
      //文件上传请求
      var xhr = new XMLHttpRequest();

      xhr.open("POST", this.baseURL + "/client.inventoryExcelUpload", true);
      xhr.setRequestHeader(
        "Admintoken",
        "Bearer " + localStorage.getItem("japan_access_token")
      );
      xhr.onload = () => {
        if (xhr.status === 200) {
          const res = JSON.parse(xhr.responseText);
          this.handleAvatarSuccess(res);
        } else {
          // console.log("An error occurred while uploading the file.");
        }
      };
      xhr.send(formData);
    },
    //文件上传前吹
    beforeAvatarUpload(file) {
      const isXls =
        [
          "application/vnd.ms-excel",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ].indexOf(file.type) !== -1;
      if (!isXls) {
        // 文件格式仅限Xls和Xlsx
        this.$message.error(
          this.$t("message.fileFormatLimitedToXlsAndXlsxOnly")
        );
        return isXls;
      }
      this.loading = this.$loading({
        lock: true,
        // 文件上传中
        text: this.$t("message.fileUploadInProgress"),
        spinner: "el-icon-loading fontSize50",
        background: "rgba(255, 255, 255, 0.7)",
      });
    },
    //上传成功
    handleAvatarSuccess(res, file) {
      this.loading.close();
      if (res.code != 0) {
        this.$message.error(res.msg);
        return;
      }
      this.$parent.$parent.excelImportDialogVisible = false;
      this.$parent.$parent.getData();
    },
    //删除文件
    deleteFileList(index) {
      this.uploadFileList.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-link {
  width: max-content;
  .flexAndCenter {
    padding: 0 10px !important;
  }
}
.excelImportContainer {
  header {
    border-radius: 6px;
    border: 1px solid #dfdfdf;
    background: #f9f9f9;
    padding: 25px;
    height: 130px;
    margin-top: 26px;

    .headerText {
      font-size: 14px;
      margin-bottom: 19px;
      color: #333333;
    }

    .flexAndCenter {
      height: 34px;
      background: #b4272b;
      border-radius: 8px;
      color: #fff;
      font-size: 14px;
      padding-left: 20px;

      img {
        width: 18px;
        height: 18px;
        margin-right: 6px;
      }
    }
  }

  section {
    border-radius: 6px;
    border: 1px solid #dfdfdf;
    background: #f9f9f9;
    padding: 25px;
    margin-top: 26px;

    .sectionTitle {
      margin-bottom: 20px;
    }

    .uploadContainer {
      background: #ffffff;
      border: 1px solid #dfdfdf;
      border-radius: 8px;
      padding: 25px 0;
      flex-direction: column;

      .uploadHeaderContainer {
        flex-direction: column;
        cursor: pointer;

        img {
          width: 64px;
          height: 50px;
          margin-bottom: 10px;
        }

        div {
          color: #b4272b;
          font-size: 14px;
        }
      }

      .uploadFooterContainer {
        color: #999999;
        font-size: 12px;
        margin-top: 26px;
      }
      :deep().upload-demo {
        .el-upload-dragger {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          border: none;
          width: 300px;
        }
      }
    }
  }

  .uploadFileContainer {
    margin-top: 32px;

    .fileContainer {
      margin-bottom: 21px;

      div {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-left: 3px;
        cursor: pointer;
        margin-right: 12px;
        width: 150px;
        font-size: 14px;
      }
    }
  }

  footer {
    margin-top: 32px;
    margin-left: 47px;

    div {
      width: 120px;
      height: 34px;
      background: #ffffff;
      border: 1px solid #b4272b;
      border-radius: 8px;
      line-height: 34px;
      cursor: pointer;
      font-size: 14px;
      color: #b4272b;
      text-align: center;
    }

    div:first-child {
      margin-right: 26px;
    }

    div:last-child {
      color: #fff;
      background: #b4272b;
    }
  }
}
</style>
